import { render, staticRenderFns } from "./batchBorderPath.vue?vue&type=template&id=b4c0dc12&scoped=true"
import script from "./batchBorderPath.vue?vue&type=script&lang=js"
export * from "./batchBorderPath.vue?vue&type=script&lang=js"
import style0 from "./batchBorderPath.vue?vue&type=style&index=0&id=b4c0dc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c0dc12",
  null
  
)

export default component.exports